const Keyboard = (function () {
    'use strict'

    const init = function () {
        $(window).on('keydown', (e) => {
            let keyCode = e.keyCode || e.which;
            if (keyCode == 9) {
                $('html').attr('is-keyboard-user', '');
            }
            $(window).one('mousemove', () => {
                $('html').removeAttr('is-keyboard-user');
            });
        });
    }

    return {
        init: init,
    }
})();
